export default "__VITE_ASSET__4398237b__"